import React from "react";
import { Card } from "react-bootstrap";

const MetricCard = ({ title, value, icon, color, trend, trendPositive, subtitle }) => {
  return (
    <Card className="metric-card shadow-sm h-100">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-start">
          <div className="flex-grow-1">
            <div className="metric-title text-muted mb-2">{title}</div>
            <div className="metric-value" style={{ color: color }}>
              {value}
            </div>
            {subtitle && (
              <div className="metric-subtitle text-muted small mt-1">{subtitle}</div>
            )}
            {trend && (
              <div className={`metric-trend mt-2 ${trendPositive ? 'trend-positive' : 'trend-negative'}`}>
                <i className={`fas ${trendPositive ? 'fa-arrow-up' : 'fa-arrow-down'} me-1`}></i>
                {trend}
              </div>
            )}
          </div>
          <div className="metric-icon" style={{ backgroundColor: `${color}20`, color: color }}>
            <i className={`fas ${icon}`}></i>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default MetricCard;
